export const recommendedColors = [
  // Neutral (500, 600, 700, 800)
  ['#717680', '#535862', '#414651', '#252B37'],
  // Primary
  ['#0BA5EC', '#0086C9', '#026AA2', '#065986'],
  // Danger
  ['#F04438', '#D92D20', '#B42318', '#912018'],
  // Warning
  ['#F79009', '#DC6803', '#B54708', '#93370D'],
  // Success
  ['#16B364', '#099250', '#087443', '#095C37'],
  // Moss
  ['#669F2A', '#4F7A21', '#3F621A', '#335015'],
  // Green Light
  ['#66C61C', '#4CA30D', '#3B7C0F', '#326212'],
  // Teal
  ['#15B79E', '#0E9384', '#107569', '#125D56'],
  // Cyan
  ['#06AED4', '#088AB2', '#0E7090', '#155B75'],
  // Blue Dark
  ['#2970FF', '#155EEF', '#004EEB', '#0040C1'],
  // Violet
  ['#875BF7', '#7839EE', '#6927DA', '#5720B7'],
  // Purple
  ['#7A5AF8', '#6938EF', '#5925DC', '#4A1FB8'],
  // Fuchsia
  ['#D444F1', '#BA24D5', '#9F1AB1', '#821890'],
  // Pink
  ['#EE46BC', '#DD2590', '#C11574', '#9E165F'],
  // Rose
  ['#F63D68', '#E31B54', '#C01048', '#A11043'],
  // Orange Dark
  ['#FF4405', '#E62E05', '#BC1B06', '#97180C'],
  // Yellow
  ['#EAAA08', '#CA8504', '#A15C07', '#854A0E']
];
